<template>
  <div class="mapcom">
    <div id="container"></div>

    <div class="contact_us_box">
      <!-- <div class="txt_img_content">
        <img src="@/assets/image/Public/QR1.jpg" alt="" />
      </div> -->
      <div class="txt_box_content">
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="title">{{$t('Contact.Name')}}</div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="contact_txt">
            <div class="name">{{$t('Contact.Addres')}}:</div>
            <div class="txt">{{$t('Contact.AddresText')}}</div>
          </div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>

          <div class="contact_txt">
            <div class="name">{{$t('Contact.Postcode')}}:</div>
            <div class="txt">{{$t('Contact.PostcodeText')}}</div>
          </div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="contact_txt">
            <div class="name">{{$t('Contact.Phone')}}:</div>
            <div class="txt">{{$t('Contact.PhoneText')}}</div>
          </div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="contact_txt">
            <div class="name">{{$t('Contact.Fax')}}:</div>
            <div class="txt">{{$t('Contact.FaxText')}}</div>
          </div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="contact_txt">
            <div class="name">{{$t('Contact.NetWork')}}:</div>
            <div class="txt">
           {{$t('Contact.NetWorkText')}}
            </div>
          </div>
        </div>
        <div class="txt_box">
          <i class="iconfont"></i>
          <div class="contact_txt">
            <div class="name">{{$t('Contact.Email')}}:</div>
            <div class="txt">{{$t('Contact.EmailText')}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    const self = this;

    return {
      map: null,
    };
  },
  watch: {
    language(val) {
      if (val == "zh") {
        this.map.setLang("zh_cn");
      } else {
        this.map.setLang("en");
      }
    },
  },
  mounted() {
    //初始化地图

    this.map = new AMap.Map("container", {
      resizeEnable: true,

      center: [116.28199417803572, 40.071981471428835],
      zoom: 10,
    });

    var marker = new AMap.Marker({
      resizeEnable: true,

      //   icon: "//http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
    //   label: {
    //     content: "可持续发展大数据国际研究中心",
    //     offset: [-20, -30],
    //   },
      position: [116.28199417803572, 40.071981471428835],

      offset: new AMap.Pixel(-10, -10),
    });

    marker.setMap(this.map);
    if (this.language == "zh") {
        this.map.setLang("zh_cn");
      } else {
        this.map.setLang("en");
      }
    //绑定radio点击事件

    // var radios = document.querySelectorAll("#lang input");

    // radios.forEach(function (ratio) {
    //   ratio.onclick = setLang;
    // });

    // function setLang() {
    //   map.setLang(this.id);
    // }
  },
};
</script>


<style  lang="scss">
.amap-marker-label {
  position: absolute;
  z-index: 2;
  border: 1px solid #ccc;
  background-color: white;
  white-space: nowrap;
  cursor: default;
  padding: 3px;
  font-size: 12px;
  line-height: 14px;
}
.amap-logo {
  display: none;
  opacity: 0 !important;
}
.amap-copyright {
  opacity: 0;
}
.contact_us_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  .txt_img_content {
    img {
      width: 150px;
      height: 150px;
    }
  }
  .txt_box_content {
    display: flex;
    flex-direction: column;
    padding: 10px;
    .txt_box {
      .title {
        font-size: 18px;
        font-weight: 600;
      }
      .contact_txt{
          display: flex;
          flex-direction: row;
          .name{
              margin-right: 10px;;
          }
          .txt{
              flex-wrap: wrap;
          }
      }
      margin-bottom: 10px;
    }
  }
}

.mapcom {
  margin-top: 70px;
}
#container {
  height: 400px;
}

.input-card {
  position: absolute;

  bottom: 10px;

  right: 10px;

  padding: 15px;

  background: #fff;

  text-align: left;

  border-radius: 5px;
}

#lang {
  padding: 5px 0;
}

.input-item {
  line-height: 24px;
}
</style>